const sectionCardVideoSliderCss = `
[data-type='section-card-video-slider'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-video-slider'] .card-header h1,
[data-type='section-card-video-slider'] .card-header h2,
[data-type='section-card-video-slider'] .card-header h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-video-slider'] .card-header p {
  font-size: 16px;
  margin-bottom: 16px !important;
}

[data-type='section-card-video-slider'] .swiper {
  position: relative;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item {
  position: relative;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item video {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .playvideo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  pointer-events: none;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .playvideo svg {
  width: 24px;
  height: 24px;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .volume {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

[data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .volume svg {
  width: 20px;
  height: 20px;
}

[data-type='section-card-video-slider'] .swiper .button-next,
[data-type='section-card-video-slider'] .swiper .button-prev {
  z-index: 99;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
}

[data-type='section-card-video-slider'] .swiper .button-next svg,
[data-type='section-card-video-slider'] .swiper .button-prev svg {
  width: 30px;
  height: 30px;
}

[data-type='section-card-video-slider'] .swiper .button-next.swiper-button-disabled,
[data-type='section-card-video-slider'] .swiper .button-prev.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

[data-type='section-card-video-slider'] .swiper .button-next.swiper-button-lock,
[data-type='section-card-video-slider'] .swiper .button-prev.swiper-button-lock {
  display: none;
}

[data-type='section-card-video-slider'] .swiper .button-prev {
  left: 10px;
}

[data-type='section-card-video-slider'] .swiper .button-next {
  right: 10px;
}

@container (max-width: 768px) {
  [data-type='section-card-video-slider'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-video-slider'] .card-header h1,
  [data-type='section-card-video-slider'] .card-header h2,
  [data-type='section-card-video-slider'] .card-header h3 {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-card-video-slider'] .card-header p {
    font-size: 14px;
  }
}

@container (max-width: 900px) {
  [data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .playvideo {
    width: 40px;
    height: 40px;
  }

  [data-type='section-card-video-slider'] .swiper .swiper-wrapper .wrap-item .playvideo svg {
    width: 20px;
    height: 20px;
  }
}
`;

export default sectionCardVideoSliderCss;
